import * as React from "react";
import * as i18next from "i18next";
import * as noCache from "shortid";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { item } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <li className="vcart-incidents" style={{ height: "90%" }}>
      <div className="cart-incident">
        <div className="no-active-camera">
          <div className="image-snapshot  animated fadeIn">
            <div className="image-lapi">
              <img
                src={
                  item &&
                  item.plateInfoDto &&
                  item.plateInfoDto.contextImageUrl +
                    "?nocache=" +
                    noCache.generate()
                }
                alt={item.codeCamera}
              />{" "}
            </div>
            <div className="image-lapi">
              <img
                src={
                  item &&
                  item.plateInfoDto &&
                  item.plateInfoDto.imageUrl + "?nocache=" + noCache.generate()
                }
                alt={item.codeCamera}
              />{" "}
            </div>
          </div>
          <div className="image-snapshot-footer-infos">
            <span>
              {i18next.t("cam")} {item.codeCamera}
            </span>
          </div>
        </div>
      </div>
    </li>
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  item?: any;
  rediRectToo?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/box/camera-tmd-lapi/component.tsx